import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { UserUtils } from '@/utils/userUtils';
import { ApiResult } from '@/enums';
import { Consts } from '@/consts';
import { Groups } from '@/models/groups';
import { Group } from '@/models/group';
import { GroupUtils } from '@/utils/groupUtils';
import { AppConfig } from '@/app-config';
import { GraphApiResult } from '@/models/graphApiResult';
import { Users } from '@/models/users';

@Component({
	components: {}
})
export default class Admin extends Vue {
	@Prop() public groupName!: string;
	public get isVisible(): boolean {
		return true;
	}
	private isAuthenticated: boolean = false;

	@Emit("get-user-name")
	public getUserName(name: string): void { }

	@Emit("get-groups")
	public getGroups(groups: Groups): void { }

	public async created(): Promise<void> {
		try {
			// アクセストークンが有効でない場合はルートに遷移。
			if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
				this.$router.push(Consts.PATH_ADMIN);
				return;
			}
			const accessToken: string = Vue.$accessTokenInfo.token;
			// Userの取得
			const userResult = await UserUtils.GetMe(accessToken);
			if (userResult.result !== ApiResult.Success) {
				return;
			}
			const user = userResult.value;
			if (user === null) {
				return;
			}
			// 「運営」セキュリティグループへの所属を確認
			// ここではログイン状態そのものは取り消さない
			const adminMembersResult: GraphApiResult<Users> =
				await GroupUtils.GetMembers(accessToken, AppConfig.ADMIN_SECUTIRY_GROUP_ID);
			if (adminMembersResult.result !== ApiResult.Success) {
				// AdminHomeにルーティングする。現在のパスがAdminHomeの場合は何も起こらないため具体的な対応はAdminHome側で行う。
				this.$router.push(Consts.PATH_ADMIN);
				return;
			}
			const adminMembers: Users | null = adminMembersResult.value;
			if ((adminMembers === null) || (adminMembers.value.length === 0) || (!adminMembers.belongs(user.id))) {
				// AdminHomeにルーティングする。現在のパスがAdminHomeの場合は何も起こらないため具体的な対応はAdminHome側で行う。
				this.$router.push(Consts.PATH_ADMIN);
				return;
			}
			localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_ID, user.id);
			localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_DISPLAYNAME, user.displayName);
			this.getUserName(user.displayName);
			// Teamの取得
			const teamsResult = await GroupUtils.GetJoinedTeams(accessToken);
			if ((teamsResult.result !== ApiResult.Success) || (teamsResult.value === null)) {
				return;
			}
			const teams: Groups = teamsResult.value;
			const groupId: string | null = localStorage.getItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
			if ((groupId !== null) && GroupUtils.IsPermitted(groupId)) {
				// キャッシュを利用する
				const permittedTeams: Groups = GroupUtils.GetPermittedGroups(teams);
				if (permittedTeams.value.length > 0) {
					this.getGroups(permittedTeams);
				} else {
					// メンバー外の可能性あり TODOメッセージ表示
					localStorage.removeItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
				}
			} else {
				const permittedTeams: Groups = GroupUtils.GetPermittedGroups(teams);
				if (permittedTeams.value.length > 0) {
					localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID, permittedTeams.value[0].id);
					this.getGroups(permittedTeams);
				} else {
					// 管理権限設定ミスの可能性あり TODOメッセージ表示
				}
			}
		} finally {
			this.isAuthenticated = true;
		}
	}

	@Emit('show-logout-confirmation')
	private showLogoutConfirmation(title: string, message: string): void { }

	private updateAdminHome(displayName: string, groups: Groups): void {
		this.getUserName(displayName);
		this.getGroups(groups);
	}

	private async showAdminLogoutConfirmation(title: string, message: string): Promise<void> {
		this.showLogoutConfirmation(title, message);
	}
}
